<template>
  <div class="mx-3">
    <v-row>
      <v-col
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <setup-claims-backup-approver-dialog-create
          v-if="$hasPermissionTo(['create backup approvers'])"
          :employees="employees"
          @created="loadData"
        />
      </v-col>
      <v-spacer />

      <v-col
        class="py-0"
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <v-select
          v-model="statusFilter"
          :items="items"
          item-text="state"
          item-value="value"
          label="Backup Approver's Status"
          placeholder="Active / Deleted"
        />
      </v-col>

      <v-col
        class="py-0"
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <v-text-field
          v-model="search"
          placeholder="Key in name here"
          append-icon="search"
          label="Search Backup Approver"
          hide-no-data
          hide-selected
          clearable 
        />
      </v-col>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="filteredBackupApprovers"
      :loading="tableLoading"
      :search="search"
    >
      <template v-slot:item.action="{ item }">
        <span
          v-if="statusFilter"
          style="display:inline-block;width:80px"
        >
          <setup-claims-backup-approver-dialog-edit
            v-if="$hasPermissionTo(['update backup approvers'])"
            :backup-approver="item"
            :employees="employees"
            @updated="loadData"
          />
          <setup-claims-backup-approver-dialog-delete
            v-if="$hasPermissionTo(['delete backup approvers'])"
            :backup-approver="item"
            @deleted="loadData"
          />
        </span>
      </template>
    </v-data-table>
  </div>
</template>

<script>
  export default {
    components: {
      SetupClaimsBackupApproverDialogCreate: () => import('@/components/hris/setup/claims/backup-approver/DialogCreate'),
      SetupClaimsBackupApproverDialogEdit: () => import('@/components/hris/setup/claims/backup-approver/DialogEdit'),
      SetupClaimsBackupApproverDialogDelete: () => import('@/components/hris/setup/claims/backup-approver/DialogDelete'),
    },
    data () {
      return {
        backupApprovers: [],
        trashedBackupApprovers: [],
        headers: [
          {
            text: 'Delegator',
            align: 'left',
            value: 'delegator.person.name',
          },
          {
            text: 'Backup',
            align: 'left',
            value: 'employee.person.name',
          },
          {
            text: 'Start Date',
            align: 'center',
            value: 'start_date',
          },
          {
            text: 'End Date',
            align: 'center',
            value: 'end_date',
          },
          {
            text: '',
            sortable: false,
            value: 'action',
          },
        ],
        search: '',
        statusFilter: { state: 'Active', value: true },
        items: [
          { state: 'Active', value: true },
          { state: 'Deleted', value: false },
        ],
        tableLoading: true,
        combinedBackupApprovers: [],
        employees: [],
      }
    },
    computed: {
      filteredBackupApprovers () {
        return this.statusFilter ? this.backupApprovers : this.trashedBackupApprovers
      },
    },
    created () {
      this.loadData()
    },
    methods: {
      loadData () {
        this.tableLoading = true
        
        Promise.all([
          this.$api.backupApprovers().list(),
          this.$api.backupApprovers().listTrashed(),
          this.$api.employees().list('?with=active'),
        ]).then(([backupApprovers, trashedBackupApprovers, employees]) => {
          this.backupApprovers = _.orderBy(backupApprovers.data, ['delegator.person.name'], ['asc'])
          this.trashedBackupApprovers = _.orderBy(trashedBackupApprovers.data, ['delegator.person.name'], ['asc'])
          
          let temp = employees.data.filter(employee => {
            return employee.status === 'complete'
          })
          this.employees = _.orderBy(temp, ['person.name'], ['asc'])

          this.combinedBackupApprovers = backupApprovers.data.concat(trashedBackupApprovers.data)

          this.tableLoading = false
        })
      },
    },
  }
</script>
